import { ChangeDetectorRef,Component, OnInit, ViewChild, AfterViewInit,Input } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TransactionService } from '../../../Services/transaction.service';
import { Router } from '@angular/router';
import { Utility } from '../../../Utilities/utility';
import { CookieService } from 'ngx-cookie-service';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { SpraRentalEmiComponent } from '../../masters/spra-rental-emi/spra-rental-emi.component';
import { SpraRentalPLComponent } from '../../masters/spra-rental-pl/spra-rental-pl.component';
import { SpraViewConsigneeComponent } from '../../masters/spra-view-consignee/spra-view-consignee.component';
import { MultipleFileUploadComponent } from '../../masters/multiple-file-upload/multiple-file-upload.component';
import { UploadFileData } from 'src/app/Models/master';
import { NotionalCounterDetail, NotionalInput } from 'src/app/Models/ops';
import { SpraNotionalInputComponent } from '../../masters/spra-notional-input/spra-notional-input.component';

interface CustomColumn {
  possition: number;
  name: string;
  isActive: boolean;
} 

@Component({
  selector: 'app-spra-view-data',
  templateUrl: './spra-view-data.component.html',
  styleUrls: ['./spra-view-data.component.css']
})
export class SpraViewDataComponent implements OnInit,AfterViewInit {
 @Input() SPRAId: number = 0;
 @Input() IsForPriceRef:boolean;
 @Input() ProfitTag: boolean = false;
 //Added by rahul yadav on 15/7/2021 for consignee view and fileupload view
 @ViewChild(SpraViewConsigneeComponent) SpraViewConsigneeComponent!: SpraViewConsigneeComponent;
 @ViewChild(MultipleFileUploadComponent) MultipleFileUploadComponent !: MultipleFileUploadComponent;

  public SPRAPartList: String[] = ["ProductCode", "ProductDesc", "PGroup", "Grade", "Quantity","UnitPrice","TotPrice"];
//  public  AMCVList : String[] = ["CounterId", "EMCL", "TotalCopy", "CounterDesc","TotalQtyConsumption", "Price"];
//  public CompetitorList: String[] = ["CompType", "CompName", "CompModel", "CompPrice"];
public CompetitorList: String[] = ["CompName", "CompModel", "CompPrice"];
public  AMCVList : String[] = ["CounterDesc","ExistingCSARate", "EMCL", "TotalCopy", "ProductCode","TotalQtyConsumption","Price"];
public SPRADetail:any;
public ISService:boolean;
public ISSpraHavingFinishGoods:boolean=false;
public ParentSpraDetails:any={};
//public ProfitTag:boolean;
  PartdataSource = new MatTableDataSource<any>();
  CompdataSource = new MatTableDataSource<any>();
  AMCVdataSource = new MatTableDataSource<any>();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  utility: Utility;

  constructor(private router: Router,
    private _TransactionService:TransactionService,
    private _CookieService: CookieService,
    private intl: MatPaginatorIntl,
    private dialog: MatDialog,
     private changeDectector: ChangeDetectorRef
  ) {
    this.utility = new Utility(this._CookieService);
    this.sort = new MatSort();
     this.paginator = new MatPaginator(this.intl, this.changeDectector);
     this.ISService=false;
     this.IsForPriceRef  = false;
     //this.ProfitTag=false;
    // this.ISService=true;
    let param: any = this.router.getCurrentNavigation()?.extras.state;
    if (param) {     
      this.SPRAId = param.SPRAId;
      if(param.IsForPriceRef != undefined){
        this.IsForPriceRef = param.IsForPriceRef;
      }
      
      this.ISService = param.ISService;
      if(param.ISService==undefined){ //Added By rahul yadav on 26/05/2021
        this.ISService = true;
      }
     
      
      
      
      
     // this.SPRAId = 20;
       //alert(this.ISService);
      
    }
   }
  ngAfterViewInit(): void {
  
    if (this.ISService){  //Added By rahul yadav on 26/05/2021
       this.SPRAPartList = ["ProductCode", "ProductDesc", "PGroup", "Grade", "Quantity"];
    }
    // this.PartdataSource.sort = this.sort;
  }

  ngOnInit(): void {  

    // this.SPRAId = 250;
  // this.SPRAId = 186;
    // this.RefId = 910421;
    // this.paymentAgingParam.saleCode  = "WM92420";
    // this.paymentAgingParam.officeId = 14;
    // this.paymentAgingParam.CompanyId = 80831796;   

    this.GetSpraRequestListById();
    //Added by rahul yadav on 14/07/2021 for consigneeDetails
    if(!this.ISService){
      setTimeout(() => {
        this.ISSpraHavingFinishGoods = this.GetFinishedGoodsTag()
       }, 1000);
    }
   if(!this.ISService){
      setTimeout(() => {
       if (this.SpraViewConsigneeComponent != undefined && this.SPRADetail.ConsigneeDetails != undefined) {
       this.SpraViewConsigneeComponent.ConsineeDetails = this.SPRADetail.ConsigneeDetails;
       }
       
      }, 1500);
    }
      setTimeout(() => {
        this.BindFileUploadDetail();
      }, 2000);
    
  }
  
  // async ngOnInit() {
  //   await this.GetSpraRequestListById();
  // }
//Added by rahul yadav on 14/7/2021 to get finished goods tag
  GetFinishedGoodsTag()
  {
    if (this.SPRADetail.ProdDetail.filter(function (item: any) {
      return item?.ProductGroupId == 1
    }).length > 0) {
      return true;
    } else {
      return false;
    }
  }
  GetSpraRequestListById(){
    if(this.SPRAId>0){
      // debugger
    this._TransactionService.GetAllSPRARequestById(this.SPRAId,this.IsForPriceRef).subscribe((d:any)=>{      
      this.SPRADetail= JSON.parse(d);
      // if(this.SPRADetail.PriceRefCalculations==undefined || this.SPRADetail.PriceRefCalculations==''){
      //   this.ProfitTag = false;
      // }
  
      this.PartdataSource.data= this.SPRADetail.ProdDetail;
      this.ParentSpraDetails = this.SPRADetail.ParentSpraDetails;
      setTimeout(() => {        
        this.PartdataSource.sort = this.sort;
      });  
    },(error) => {                              //Error callback
      this.utility.Error(error);
    });
  }
  
  }


  OpenEmiDetail(){
    const dialogRef = this.dialog.open(SpraRentalEmiComponent, {
      width: '100%',
      data: { spraRentalEmiModel: this.SPRADetail.PriceRefCalculations?.EMI}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data != undefined) {
      }
    });
  }

  
  OpenPLDetail(): void {
    const dialogRef = this.dialog.open(SpraRentalPLComponent, {
      width: '100%',
      data: { spraRentalPL: this.SPRADetail.PriceRefCalculations?.PL , CounterDetail:this.SPRADetail.Amcv.CounterDetail }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data != undefined) {
      }
    });
  }

//added by rahul yadav on 15/7/2021 to bind fileupload details
  BindFileUploadDetail(){
    

     //&& !this.ISService condition remove by rahul yadav to show file upload on service page 
    if (this.SPRADetail?.Documents != undefined && this.SPRADetail?.Documents.length > 0 ) {
      this.MultipleFileUploadComponent.UploadFileData = new Array<UploadFileData>();
      let uploadFileData: UploadFileData = new UploadFileData();
      this.MultipleFileUploadComponent.mode = "U";
      this.SPRADetail.Documents.forEach((element: any, index: number) => {
        let uploadFileData: UploadFileData = new UploadFileData()
        uploadFileData.Purpose = element.purpose;
        uploadFileData.IsNewRow = true;
         this.MultipleFileUploadComponent.FromView = true;
        let file: File = new File([" "], element.purpose);
        uploadFileData.File = file;
        uploadFileData.disable = true;
        uploadFileData.DownloadFilePath = element.fileName;
        this.MultipleFileUploadComponent.UploadFileData.push(uploadFileData)
        if (index == this.SPRADetail.Documents.length - 1) {
         // this.MultipleFileUploadComponent.addRow(uploadFileData, 1);
        }
      });
    } else {
      //uploadFileData = new UploadFileData();
     // this.MultipleFileUploadComponent.addRow(uploadFileData, 0);
    }
}
//added by rahul yadav on 16/7/2021 for notional rent view
  EnterNotionalRentDetail(){
    let _NotionalInput:NotionalInput = new NotionalInput();  
    if(this.SPRADetail.Amcv.NotionalInput != undefined && this.SPRADetail.Amcv.NotionalInput.CounterDetail.length>0){
      _NotionalInput =  this.SPRADetail.Amcv.NotionalInput;
    }else{
      
      _NotionalInput.CounterDetail = this.SPRADetail.Amcv.CounterDetail.map((mc:any)=>{
            let _NotionalCounter:NotionalCounterDetail = new NotionalCounterDetail()
            _NotionalCounter.CounterId = mc.CounterId;
            _NotionalCounter.CounterDesc = mc.CounterDesc;
            return _NotionalCounter;
          })
  
    }
    
    const dialogRef = this.dialog.open(SpraNotionalInputComponent, {
      width: '100%',
      height:'50%',
      data: {_NotionalInput: _NotionalInput,FromView:true}
      
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data != undefined) {
        // this.SpraRentalAmcvModel.MonthlyRent = result.data.NotionalInput.Rent;
        // this.SpraRentalAmcvModel.NotionalInput =  result.data.NotionalInput;
        // this.CalculateRentFromNotionalRent();
        // let NotionalDiscount=0;
        // this.SpraRentalAmcvModel.CounterDetail.map((mc)=>{
        //   let _NotionalCounterDetail:NotionalCounterDetail = this.SpraRentalAmcvModel.NotionalInput.CounterDetail.filter(mnc=> {return mnc.CounterId == mc.CounterId})[0];
        //   mc.CustomerCommitmentCopy = _NotionalCounterDetail.Commitment;
        //   NotionalDiscount += (_NotionalCounterDetail.Commitment*mc.CSACostRate);
        // });
        
        // this.SpraRentalAmcvModel.MonthlyRent =Math.round(this.SpraRentalAmcvModel.MonthlyRent - NotionalDiscount);
      }
    });
  }

  onRequestClick(){
    let data =  {IsForPriceRef:false,SPRAId: this.ParentSpraDetails[0].Id,RefId:this.ParentSpraDetails[0].RefId,salecode:this.ParentSpraDetails[0].SaleCode,officeId:this.ParentSpraDetails[0].OfficeID,CompanyID:this.ParentSpraDetails[0].CompanyId,ProfitTag:this.ProfitTag };
   // this.router.navigateByUrl("spra-view-ops",{ state:{data:data}});
    this.router.navigate([], {
      state: data
    }).then(result => {  
      window.open("spra-view-ops/"+btoa(JSON.stringify(data)) +"", '');     
    });
   }
}
